<template>
  <v-list-tile v-if="!isEditing" avatar ripple class="it-hv">
    <v-list-tile-avatar>
      <font-awesome-icon :icon="['fal', 'birthday-cake']"></font-awesome-icon>
    </v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-sub-title class="caption" v-if="!isPrintEmpty">生年月日</v-list-tile-sub-title>
      <v-list-tile-title>{{ printBirthday }} {{ printAge }}</v-list-tile-title>
    </v-list-tile-content>
    <v-list-tile-action>
      <v-tooltip bottom>
        <v-btn flat icon slot="activator" class="blue--text text--darken-2" :loading="isThisLoading" @click="edit"><font-awesome-icon :icon="['fal', 'pencil']"/></v-btn>
        <span>編集する</span>
      </v-tooltip>
    </v-list-tile-action>
  </v-list-tile>
  <v-container v-else>
    <v-layout wrap class="pb-4">
      <v-flex xs12 class="px-3">
        <v-menu lazy offset-y full-width
          v-model="config.datepicker.birthday"
          transition="scale-transition"
          min-width="290px"
          :close-on-content-click="false">
          <v-text-field readonly required
            v-model="printFormatedBirthday"
            :rules="rules.birthday"
            slot="activator"
            label="生年月日"></v-text-field>
          <v-date-picker
            v-model="form.birthday.content"
            color="amber"
            locale="ja"
            :day-format="date => new Date(date).getUTCDate()"
            @input="config.datepicker.birthday = false"></v-date-picker>
        </v-menu>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
export default {
  name: 'clientAboutBasicBirthday',
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      config: {
        datepicker: {
          birthday: false
        }
      },
      form: {
        birthday: {
          id: '',
          content: ''
        }
      },
      rules: {
        birthday: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function () {
      if (
        this.$props.data &&
        this.$props.data.birthday
      ) {
        this.$set(this.form, 'birthday', {
          id: '' + (this.$props.data.birthday.id ? this.$props.data.birthday.id : 'new_birthday'),
          content: this.$props.data.birthday.content ? this.$moment(this.$props.data.birthday.content).format('YYYY-MM-DD') : ''
        })
      } else {
        this.$set(this.form, 'birthday', {
          id: 'new_birthday',
          content: ''
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          type: 'birthday'
        }
      })
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        ['birthday', 'all'].includes(this.$props.status.editing)
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.status.editing === 'birthday'
      )
    },
    isLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        ['birthday', 'all'].includes(this.$props.status.loading)
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.status.loading === 'birthday'
      )
    },
    isPrintEmpty () {
      return !(
        this.$props &&
        this.$props.data &&
        this.$props.data.birthday &&
        this.$props.data.birthday.content
      )
    },
    printBirthday () {
      return (
        this.$props &&
        this.$props.data &&
        this.$props.data.birthday &&
        this.$props.data.birthday.content
      ) ? this.$moment(this.$props.data.birthday.content).format('YYYY/MM/DD') : '生年月日'
    },
    printFormatedBirthday () {
      return (
        this.form &&
        this.form.birthday &&
        this.form.birthday.content
      ) ? this.$moment(this.form.birthday.content).format('YYYY/MM/DD') : ''
    },
    printAge () {
      if (
        this.$props &&
        this.$props.data &&
        this.$props.data.birthday &&
        this.$props.data.birthday.content
      ) {
        let dts = this.$moment(this.$props.data.birthday.content)
        let today = [
          new Date().getFullYear(),
          new Date().getMonth() + 1,
          new Date().getDate()
        ]
        return ([
          '（',
          today[0] - dts.year() + (
            (
              (today[1] > (dts.month() + 1)) ||
              ((today[1] === (dts.month() + 1)) && today[2] >= dts.date())
            ) ? 0 : -1
          ),
          '歳）'
        ].join(''))
      } else {
        return ''
      }
    }
  }
}
</script>
